import React, { useEffect, useState } from "react";
import { Button } from "./ui/button";

export const PoweredBy = ({ light = false, className = "" }) => (
  <a
    href="https://cityworthbenefit.com"
    target="_blank"
    rel="noreferrer"
    className={`inline-flex items-center gap-1 text-[9px] font-semibold uppercase tracking-[0.12em] ${
      light ? "text-white/60 hover:text-white/90" : "text-slate-400 hover:text-slate-600"
    } transition-colors duration-200 ${className}`}
    data-testid="powered-by-cityworth"
  >
    Powered by
    <img src="/cityworth-logo.png" alt="CityWorth" className="h-3.5 w-auto" draggable={false} />
  </a>
);

export const Logo = ({ light = false, className = "h-8" }) => (
  <a href="#top" className="flex items-center select-none" aria-label="DubbleUpp home" data-testid="site-logo">
    <img
      src="/dubbleupp-logo.svg"
      alt="DubbleUpp"
      className={`${className} w-auto ${light ? "brightness-0 invert" : ""}`}
      draggable={false}
    />
  </a>
);

const Header = ({ onGetStarted }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-shadow duration-300 ${
        scrolled ? "border-slate-200 bg-white/95 shadow-md backdrop-blur" : "border-slate-200 bg-white/90 backdrop-blur"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 lg:px-8">
        <Logo />
        <div className="flex items-center gap-3">
          <Button
            data-testid="header-get-started-btn"
            onClick={onGetStarted}
            className="rounded-full bg-[#3CC54F] px-6 py-2.5 text-[15px] font-semibold text-white shadow-sm transition-colors duration-200 hover:bg-[#25862F]"
          >
            Get Started
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
